import { UserRoleEnum } from '@monetize/types/app';
import { orderStringsBy } from '@monetize/utils/core';
import { USER_ROLES_DISPLAY } from '../../../constants/roles';
import { renderRoleItemContent } from '../../Users/InviteForm';
import { MCustomMultiSelect } from '../MCustomSelect/MCustomMultiSelect';

const ROLE_OPTIONS = orderStringsBy(Object.keys(UserRoleEnum)).map((key) => ({
  name: USER_ROLES_DISPLAY[key],
  value: key,
}));

interface UserRoleMultiSelectProps {
  value: (UserRoleEnum | string)[] | null | undefined;
  isDisabled?: boolean;
  isCloseButtonLoading?: boolean;
  onChange: (values: string[]) => void;
}

export const UserRoleMultiSelect = ({
  value,
  onChange,
  isDisabled,
  isCloseButtonLoading,
}: UserRoleMultiSelectProps) => {
  return (
    <MCustomMultiSelect
      items={ROLE_OPTIONS}
      itemTitle="name"
      itemValue="value"
      showSelectAll
      renderItemContent={renderRoleItemContent}
      value={value}
      onChange={onChange}
      closeButtonText="Apply"
      isCloseButtonLoading={isCloseButtonLoading}
      placeholder={
        value?.length === 0
          ? 'Select Role'
          : value?.length === 1
            ? USER_ROLES_DISPLAY[value[0]]
            : `${value?.length} Roles Selected`
      }
      inputProps={{
        _placeholder: {
          color: value?.length ? 'tPurple.dark' : 'inherit',
        },
      }}
      inputWidth="200px"
      ml="auto"
      isDisabled={isDisabled}
    />
  );
};
